import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

// Auth Services
import { AuthenticationService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        if (environment.defaultauth === 'firebase') {
            return this.authenticationService.authState$.pipe(
                take(1), // Take the first emitted value and complete
                map(user => {
                    if (user) {
                        // If user is logged in, return true
                        return true;
                    }
                    // If user is not logged in, redirect to login page
                    return this.router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
                })
            );
        }

        // Fallback for non-firebase auth, though it should be handled above.
        // This preserves the original logic for other potential auth types.
        if (this.authenticationService.currentUser()) {
            return of(true);
        }

        // not logged in so redirect to login page with the return url
        return of(this.router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } }));
    }
}
